import Vue from 'vue'
import Vuetify from 'vuetify'
import './plugins/vuetify'
import App from './App.vue'
import Formulaire from './components/Formulaire.vue'
import Breadcrump from './components/Breadcrump.vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
   
Vue.use(VueAxios, axios)
Vue.use(Vuetify)

Vue.config.productionTip = false

new Vue({
  render: h => h(App),
}).$mount('#app')

